// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3uzOl","additionalInfo":"AgreementModal_additionalInfo__11Zd6"};